// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/images//Artboard 4.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../assets/images//edit.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../assets/images//delete.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../../assets/images//download.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../../assets/images//exclamation-triangle.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.add-icon{
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    height: 25px;
    width: 26px;
    background-position: center;
    margin: 0 0.3rem;
    float: right;
}

/* .actionPlanTable .react-bootstrap-table {
    height: 20rem !important;
} */

.edit-icon {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
    height: 18px;
    width: 18px;
    background-position: center;
    margin: 0 0.3rem;
    pointer-events: auto;
}

.delete-icon {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
    height: 18px;
    width: 18px;
    background-position: center;
    margin: 0 0.3rem;
}

.download-icon {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
    height: 18px;
    width: 18px;
    background-position: center;
    margin: 0 0.3rem;
    pointer-events: auto;
}

.warning-icon {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
    height: 18px;
    width: 18px;
    background-position: center;
    margin: 0 0.3rem;
}

/* Table header stick  */

.actionPlanTable tbody, .actionPlanTable tr { display: block; }

.actionPlanTable tr:after {
    content: ' ';
    display: block;
    visibility: hidden;
    clear: both;
}

.actionPlanTable tbody {
    /*border: solid 1px #a8aaac;*/
    height: 20rem;
    overflow-y:scroll;
   
}

.actionPlanTable table {
    border-spacing: 3px 7px;
    border-collapse: separate;
    margin-bottom:0px !important;
}

.actionPlanTable tbody > tr > td { 
    width: 7rem; 
    float: left;
    overflow:hidden;
    max-height: 3rem;
    
    
} 
.actionPlanTable thead > tr > th { 
    width: 7rem;
    float: left;
} 
.actionPlanTable tbody tr td{
    padding-top: 10px;
    padding-bottom: 10px;
    padding-left: 20px;
}
.actionPlanTable thead tr{
    padding-left: 10px;
}

.add-icon-disabled {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    height: 25px;
    width: 26px;
    background-position: center;
    margin: 0 0.3rem;
    float: right;
    cursor: not-allowed;
}
.hideIcon {
    display: none;
}
.hideIcon1 {
    display: none;
}
.controlledIcon1{
    display: block !important;
}
.queslink:hover {
    color: #e50000;
    cursor: pointer;
  }
/* .queslink{
    cursor: pointer;
}   */
.moveBtn {
    height: 1.8rem;
    padding: 0rem 10px;
}

.parameterTableKaizen .table {
    border-collapse: inherit;
}

.modal-dialog.uploadModal-toyota.modal-dialog-centered,.modal-dialog.uploadModal-lexus.modal-dialog-centered {
    max-width: 1250px !important;
}

.iframe {
    border: 1px solid white;
    width: 200px;
    height: 150px;
    resize: both;
    /* overflow: auto; */
  }
  
  .wrapper {
    /* background-color: lightgrey; */
    height: 100%;
    /* display: flex; */
  }
  
  .image {
    margin: 0 auto;
    max-width: 100%;
    max-height: 100%;
    object-fit: contain;
  }
  .evidenceFooter {
    max-width: 1200px !important;
  }
  
  .iframeBg {
    width: 100%;
    height: 100%;
  }
  .imageModalHt {
    width: 35rem !important;
    height: auto;
  }`, "",{"version":3,"sources":["webpack://./src/components/actionPlanTable/index.css"],"names":[],"mappings":"AAAA;IACI,yDAA4D;IAC5D,YAAY;IACZ,WAAW;IACX,2BAA2B;IAC3B,gBAAgB;IAChB,YAAY;AAChB;;AAEA;;GAEG;;AAEH;IACI,yDAAsD;IACtD,YAAY;IACZ,WAAW;IACX,2BAA2B;IAC3B,gBAAgB;IAChB,oBAAoB;AACxB;;AAEA;IACI,yDAAwD;IACxD,YAAY;IACZ,WAAW;IACX,2BAA2B;IAC3B,gBAAgB;AACpB;;AAEA;IACI,yDAA0D;IAC1D,YAAY;IACZ,WAAW;IACX,2BAA2B;IAC3B,gBAAgB;IAChB,oBAAoB;AACxB;;AAEA;IACI,yDAAsE;IACtE,YAAY;IACZ,WAAW;IACX,2BAA2B;IAC3B,gBAAgB;AACpB;;AAEA,wBAAwB;;AAExB,8CAA8C,cAAc,EAAE;;AAE9D;IACI,YAAY;IACZ,cAAc;IACd,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,6BAA6B;IAC7B,aAAa;IACb,iBAAiB;;AAErB;;AAEA;IACI,uBAAuB;IACvB,yBAAyB;IACzB,4BAA4B;AAChC;;AAEA;IACI,WAAW;IACX,WAAW;IACX,eAAe;IACf,gBAAgB;;;AAGpB;AACA;IACI,WAAW;IACX,WAAW;AACf;AACA;IACI,iBAAiB;IACjB,oBAAoB;IACpB,kBAAkB;AACtB;AACA;IACI,kBAAkB;AACtB;;AAEA;IACI,yDAA4D;IAC5D,YAAY;IACZ,WAAW;IACX,2BAA2B;IAC3B,gBAAgB;IAChB,YAAY;IACZ,mBAAmB;AACvB;AACA;IACI,aAAa;AACjB;AACA;IACI,aAAa;AACjB;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,cAAc;IACd,eAAe;EACjB;AACF;;KAEK;AACL;IACI,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,wBAAsB;AAC1B;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,uBAAuB;IACvB,YAAY;IACZ,aAAa;IACb,YAAY;IACZ,oBAAoB;EACtB;;EAEA;IACE,iCAAiC;IACjC,YAAY;IACZ,mBAAmB;EACrB;;EAEA;IACE,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,mBAAmB;EACrB;EACA;IACE,4BAA4B;EAC9B;;EAEA;IACE,WAAW;IACX,YAAY;EACd;EACA;IACE,uBAAuB;IACvB,YAAY;EACd","sourcesContent":[".add-icon{\n    background-image: url(\"../../assets/images//Artboard 4.png\");\n    height: 25px;\n    width: 26px;\n    background-position: center;\n    margin: 0 0.3rem;\n    float: right;\n}\n\n/* .actionPlanTable .react-bootstrap-table {\n    height: 20rem !important;\n} */\n\n.edit-icon {\n    background-image: url(\"../../assets/images//edit.png\");\n    height: 18px;\n    width: 18px;\n    background-position: center;\n    margin: 0 0.3rem;\n    pointer-events: auto;\n}\n\n.delete-icon {\n    background-image: url(\"../../assets/images//delete.png\");\n    height: 18px;\n    width: 18px;\n    background-position: center;\n    margin: 0 0.3rem;\n}\n\n.download-icon {\n    background-image: url(\"../../assets/images//download.png\");\n    height: 18px;\n    width: 18px;\n    background-position: center;\n    margin: 0 0.3rem;\n    pointer-events: auto;\n}\n\n.warning-icon {\n    background-image: url(\"../../assets/images//exclamation-triangle.svg\");\n    height: 18px;\n    width: 18px;\n    background-position: center;\n    margin: 0 0.3rem;\n}\n\n/* Table header stick  */\n\n.actionPlanTable tbody, .actionPlanTable tr { display: block; }\n\n.actionPlanTable tr:after {\n    content: ' ';\n    display: block;\n    visibility: hidden;\n    clear: both;\n}\n\n.actionPlanTable tbody {\n    /*border: solid 1px #a8aaac;*/\n    height: 20rem;\n    overflow-y:scroll;\n   \n}\n\n.actionPlanTable table {\n    border-spacing: 3px 7px;\n    border-collapse: separate;\n    margin-bottom:0px !important;\n}\n\n.actionPlanTable tbody > tr > td { \n    width: 7rem; \n    float: left;\n    overflow:hidden;\n    max-height: 3rem;\n    \n    \n} \n.actionPlanTable thead > tr > th { \n    width: 7rem;\n    float: left;\n} \n.actionPlanTable tbody tr td{\n    padding-top: 10px;\n    padding-bottom: 10px;\n    padding-left: 20px;\n}\n.actionPlanTable thead tr{\n    padding-left: 10px;\n}\n\n.add-icon-disabled {\n    background-image: url(\"../../assets/images//Artboard 4.png\");\n    height: 25px;\n    width: 26px;\n    background-position: center;\n    margin: 0 0.3rem;\n    float: right;\n    cursor: not-allowed;\n}\n.hideIcon {\n    display: none;\n}\n.hideIcon1 {\n    display: none;\n}\n.controlledIcon1{\n    display: block !important;\n}\n.queslink:hover {\n    color: #e50000;\n    cursor: pointer;\n  }\n/* .queslink{\n    cursor: pointer;\n}   */\n.moveBtn {\n    height: 1.8rem;\n    padding: 0rem 10px;\n}\n\n.parameterTableKaizen .table {\n    border-collapse: unset;\n}\n\n.modal-dialog.uploadModal-toyota.modal-dialog-centered,.modal-dialog.uploadModal-lexus.modal-dialog-centered {\n    max-width: 1250px !important;\n}\n\n.iframe {\n    border: 1px solid white;\n    width: 200px;\n    height: 150px;\n    resize: both;\n    /* overflow: auto; */\n  }\n  \n  .wrapper {\n    /* background-color: lightgrey; */\n    height: 100%;\n    /* display: flex; */\n  }\n  \n  .image {\n    margin: 0 auto;\n    max-width: 100%;\n    max-height: 100%;\n    object-fit: contain;\n  }\n  .evidenceFooter {\n    max-width: 1200px !important;\n  }\n  \n  .iframeBg {\n    width: 100%;\n    height: 100%;\n  }\n  .imageModalHt {\n    width: 35rem !important;\n    height: auto;\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
